import { Trans } from '@lingui/macro'
import {
  createStyles,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from '@material-ui/core'
import { useReaction } from '@speedlo/hooks'
import { useLocalStore, useObserver } from 'mobx-react-lite'
import React from 'react'
import { IAccount } from 'shopify-payment-core'

import { useFirebaseFunctions } from '../hooks/useFirebaseFunctions'

interface IProps {
  account: IAccount
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 200,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }),
)

export const PaymentGatewayLanguage: React.FC<IProps> = ({ account }) => {
  const languages = React.useMemo(getLanguages, [])
  const availLanguages = languages.map(lang => lang.value)

  const classes = useStyles()
  const state = useLocalStore(() => ({
    language: availLanguages.includes(account.language!)
      ? account.language!
      : '',
  }))

  const { setLanguage } = useFirebaseFunctions()

  useReaction(
    () => state.language,
    language => {
      setLanguage({
        accountId: account.id,
        segmentKey: account.segmentKey,
        language,
      })
    },
  )

  return useObserver(() => (
    <FormControl className={classes.formControl}>
      <InputLabel htmlFor="language" shrink={true}>
        <Trans>Výchozí jazyk pro zobrazení</Trans>
      </InputLabel>
      <Select
        value={state.language}
        onChange={ev => {
          state.language = ev.target.value as string
        }}
        inputProps={{ id: 'language' }}
        displayEmpty={true}
      >
        <MenuItem value="">
          <em>
            <Trans>Automaticky</Trans>
          </em>
        </MenuItem>
        {getLanguages().map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ))
}

function getLanguages() {
  // TODO: Might be different for other segments
  return [
    { value: 'CS', label: 'Čeština' },
    { value: 'EN', label: 'Angličtina' },
    { value: 'SK', label: 'Slovenština' },
    { value: 'DE', label: 'Němčina' },
    { value: 'RU', label: 'Ruština' },
    { value: 'PL', label: 'Polština' },
    { value: 'HU', label: 'Maďarština' },
    { value: 'FR', label: 'Francouzština' },
    { value: 'RO', label: 'Rumunština' },
    { value: 'BG', label: 'Bulharština' },
    { value: 'HR', label: 'Chorvatština' },
    { value: 'IT', label: 'Italština    ' },
  ]
}
